import { ElementRef, Input, OnChanges, OnDestroy, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { FourDInjector } from '../../FourDInjector';
import { MapService } from '../../map.service';

@Component({
  selector: 'plugin-ui-section',
  templateUrl: './plugin-ui-section.component.html'
})
export class PluginUiSectionComponent implements OnInit, OnChanges, OnDestroy {

  @Input()
  plugin:any = null;

  @Input()
  item:any = null;

  @Input()
  section:any = null;

  @Input()
  lastMouseEvent:any = null;

  @ViewChild('incomingCanvasContainer',{static:true}) public incomingCanvasContainer: ElementRef;
  public incomingCanvas: HTMLCanvasElement = null;

  translate:any = null;

  translator:any = null;

  selectOpen:boolean = false;

  constructor( public sanitizer:DomSanitizer, public mapService: MapService ) {
    this.translate = FourDInjector.injector.get(TranslateService);
  }

  ngOnChanges() { 
    // console.log('@@UI-section-changes',this.plugin,this.item,this.section, this.incomingCanvas, this.incomingCanvasContainer );
    if ( this.plugin ) {
      this.translator = this.plugin.meta.translator;
    }
  }

  ngOnInit() {

    if ( this.plugin ) {
      this.translator = this.plugin.meta.translator;
    }

    if ( !this.incomingCanvasContainer ) {
      if ( this.section && this.section.canvas ) {
        this.incomingCanvas = this.section.canvas;
      }
      if ( this.incomingCanvas && this.incomingCanvasContainer ) {
        this.incomingCanvasContainer.nativeElement.appendChild(this.incomingCanvas);
      }
    }
    // console.log('@@UI-section-init', this.plugin, this.item, this.section, this.incomingCanvas, this.incomingCanvasContainer );
  }

  ngOnDestroy() {
    this.incomingCanvas = null;
    this.incomingCanvasContainer = null;
    this.plugin = null;
    this.section = null;
    this.item = null;
  }

  toggleSelect ( value:any = null, section:any = null ) {
    this.selectOpen = !this.selectOpen;
    // if these are set, it's usually a close
    if ( value && section ) {
      section.value = value;
    }
    this.plugin.refresh();
    this.plugin.save();
    /*
    setTimeout ( () => {
      if ( this.selectOpen ) {
        let e = document.getElementsByClassName('fdm-select-open');
        if ( e && e[0] ) {
          this.makeInView(e[0]);
        }
      }
    }, 300 );
    */
    // console.log('@@ toggleSelect', this.selectOpen, value, section );
  }

  radioSelect ( value:any = null, section:any = null ) {
    if ( value && section ) {
      section.value = value;
    }
    this.plugin.refresh();
    this.plugin.save();
    // console.log('@@ radioSelect', value, section );
  }

  showOptions( section:any = null ) {
    if ( section ) {
      alert(section.options);
    }
  }

  getLocalisedValue ( value:any = 10 ) {
    return value + 'm';
  }

  /*
  getPixelsFromPercent ( percent:number = 10 ) {
    // return the number of pixels that is X percent of 200 (height of a legend bar)
    return percent * 2;
  }
  */

  makeInView( e:any ) {
    let max:number = document.documentElement.scrollHeight;
    let rect = e.getBoundingClientRect();
    console.log("@@MAKE_IN_VIEW", { element: e, rect:rect } );
    let oldY = rect.y + 'px';
    let newY = ( max - rect.height ) + 'px';
    if ( rect.y + rect.height > max ) {
      // e.style.top = newY;
    }
    console.log("@@MAKE_IN_VIEW", { newY:newY, oldY:oldY, max:max, height:rect.height } );
  }

  rounding ( num:any ) {
    return Math.round(num);
  }

  /* sliders */

  /*
  thumbsize:number = 14;

  
  initSlider(slider) {

    var min = slider.querySelector('.min');
    var max = slider.querySelector('.max');
    var rangemin:number = parseInt(min.getAttribute('min'));
    var rangemax:number = parseInt(max.getAttribute('max'));
    var avgvalue = (rangemin + rangemax)/2;
    var legendnum = slider.getAttribute('data-legendnum');

    console.log('@@INIT_SLIDER',[{s:slider, i:min, a:max}]);
    

    min.setAttribute('data-value',rangemin);
    max.setAttribute('data-value',rangemax);
    

    slider.setAttribute('data-rangemin',rangemin); 
    slider.setAttribute('data-rangemax',rangemax); 
    slider.setAttribute('data-thumbsize',this.thumbsize); 
    slider.setAttribute('data-rangewidth',slider.offsetWidth);


    var lower = document.createElement('span');
    var upper = document.createElement('span');
    lower.classList.add('lower','value');
    upper.classList.add('upper','value');
    lower.appendChild(document.createTextNode(''+rangemin));
    upper.appendChild(document.createTextNode(''+rangemax));
    slider.insertBefore(lower,min.previousElementSibling);
    slider.insertBefore(upper,min.previousElementSibling);
    

    var legend = document.createElement('div');
    legend.classList.add('legend');
    var legendvalues = [];
    for (var i = 0; i < legendnum; i++) {
        legendvalues[i] = document.createElement('div');
        var val = Math.round(rangemin+(i/(legendnum-1))*(rangemax - rangemin));
        legendvalues[i].appendChild(document.createTextNode(''+val));
        legend.appendChild(legendvalues[i]);

    } 
    slider.appendChild(legend);

    this.drawSlider(slider,avgvalue);


    min.addEventListener("input", () => { this.updateSlider(min); });
    max.addEventListener("input", () => { this.updateSlider(max); });
  }

  updateSlider(el){


    var slider = el.parentElement;
    var min = slider.querySelector('.min');
    var max = slider.querySelector('.max');
    var minvalue = Math.floor(min.value);
    var maxvalue = Math.floor(max.value);
    
    console.log('@@UPDATE_SLIDER',{s:slider, i:min, a:max, el:el, minval:minvalue, maxval:maxvalue });
    

    min.setAttribute('data-value',minvalue);
    max.setAttribute('data-value',maxvalue);

    var avgvalue = (minvalue + maxvalue)/2;


    this.drawSlider(slider,avgvalue);
  }

  drawSlider ( slider:any, splitvalue:number ) {


    var min = slider.querySelector('.min');
    var max = slider.querySelector('.max');
    var lower = slider.querySelector('.lower');
    var upper = slider.querySelector('.upper');
    var legend = slider.querySelector('.legend');
    var thumbsize = parseInt(slider.getAttribute('data-thumbsize'));
    var rangewidth:number = parseInt(slider.getAttribute('data-rangewidth'));
    var rangemin:number = parseInt(slider.getAttribute('data-rangemin'));
    var rangemax:number = parseInt(slider.getAttribute('data-rangemax'));

    

    min.setAttribute('max',splitvalue);
    max.setAttribute('min',splitvalue);

    let minwidth:number = parseInt(''+this.thumbsize + ((splitvalue - rangemin)/(rangemax - rangemin))*(rangewidth - (2*this.thumbsize))); 
    let maxwidth:number = parseInt(''+this.thumbsize + ((rangemax - splitvalue)/(rangemax - rangemin))*(rangewidth - (2*this.thumbsize)));

    console.log('@@DRAW_SLIDER',[{s:slider, i:min, a:max, ss:splitvalue, minw:minwidth, maxw:maxwidth }]);



    min.style.width = minwidth+'px';
    max.style.width = maxwidth+'px';
    min.style.left = '0px';
    max.style.left = parseInt(min.style.width)+'px';
    min.style.top = lower.offsetHeight+'px';
    max.style.top = lower.offsetHeight+'px';
    legend.style.marginTop = min.offsetHeight+'px';
    slider.style.height = (lower.offsetHeight + min.offsetHeight + legend.offsetHeight)+'px';
    

    if(max.value>(rangemax - 1)) max.setAttribute('data-value',rangemax);


    max.value = max.getAttribute('data-value'); 
    min.value = min.getAttribute('data-value');
    lower.innerHTML = min.getAttribute('data-value');
    upper.innerHTML = max.getAttribute('data-value');

  }
*/
}
